import { dayJs } from '../../utils/dayjs'

const tabKeys = {
  active: 'ACTIVE',
  complete: 'COMPLETE',
  maintenance: 'maintenance',
  repair: 'repair',
  quote: 'quote',
  repDisSurvey: 'repDisSurvey',
  installation: 'installation',
}

const {
  active,
  complete,
  maintenance,
  quote,
  repDisSurvey,
  repair,
  installation,
} = tabKeys

const jobsTypesUrl = {
  MAINTENANCE: maintenance,
  REPAIR: repair,
  INSTALLATION: installation,
}

const jobTabList = {
  status: [
    {
      label: 'txt_Active',
      key: active,
    },
    {
      label: 'job_Complete',
      key: complete,
    },
  ],
  type: [
    {
      label: 'job_Maintenance',
      key: maintenance,
    },
    {
      label: 'job_Repair',
      key: repair,
    },
    {
      label: 'job_Installation',
      key: installation,
    },
    {
      label: 'job_Quote',
      key: quote,
      disabled: true,
    },
    {
      label: 'job_RepDisSurvey',
      key: repDisSurvey,
      disabled: true,
    },
  ],
}

const defaultJobTab = {
  status: jobTabList.status.at(0).key,
  type: jobTabList.type.at(1).key,
}

const columnKeys = {
  action: 'action',
  read: 'read',
  all: 'txt_All',
  jobId: 'job_Id',
  managementNumber: 'job_ManagementNumber',
  fieldEngineer: 'job_Assignee',
  contractor: 'user_Contractor',
  jobTitle: 'job_Title',
  createdDate: 'user_CreationDate',
  updatedDate: 'job_UpdatedDate',
  status: 'job_Status',
  activeDays: 'job_ActiveSince',
  dueDate: 'job_DueDate',
  installationJobId: 'job_LinkedJobID',
}

const searchByKeys = {
  jobId: 'JOB_ID',
  contractor: 'CONTRACTOR_BUSINESSNAME',
  customer: 'CUSTOMER_BUSINESSNAME',
  building: 'BUILDING_NAME',
  errorCode: 'ERROR_CODE',
}

const { jobId, contractor, customer, building, errorCode } = searchByKeys

const searchByLabels = {
  [jobId]: 'job_Id',
  [contractor]: 'job_ContractorBusinessName',
  [customer]: 'job_CustomerBusinessName',
  [building]: 'job_BuildingName',
  [errorCode]: 'job_ErrorCode',
}

const payloadType = {
  [maintenance]: 'MAINTENANCE',
  [quote]: '',
  [repDisSurvey]: '',
  [repair]: 'REPAIR',
  [installation]: 'INSTALLATION',
}

const repairForm = [
  [
    {
      key: 'brand',
      label: 'txt_Brand',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      required: true,
      md: 8,
      sm: 24,
      columnClass: 'en-validation',
    },
    {
      key: 'productSeries',
      label: 'txt_ProductSeries',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      required: true,
      md: 8,
      sm: 24,
      columnClass: 'en-validation',
    },
    {
      key: 'unitType',
      label: 'job_UnitType',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      required: true,
      md: 8,
      sm: 24,
      columnClass: 'en-validation',
    },
  ],
  [
    {
      key: 'model',
      label: 'txt_Model',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      required: true,
      md: 8,
      sm: 24,
      columnClass: 'en-validation',
    },
    {
      key: 'category',
      label: 'job_Category',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      required: true,
      md: 8,
      sm: 24,
    },
    {
      key: 'location',
      label: 'job_Location',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      required: true,
      md: 8,
      sm: 24,
    },
  ],
  [
    {
      key: 'equipmentIdentificationNumber',
      label: 'job_EquipmentSerialNumber',
      validateTrigger: 'onChange',
      inputType: 'input',
      disabled: true,
      md: 24,
      sm: 24,
    },
  ],
  [
    {
      key: 'nameplateImages',
      label: 'job_NameplateImages',
      validateTrigger: 'onChange',
      inputType: 'image',
      acceptFileTypes: '.png,.jpg,.jpeg,.webp',
      columnClass: 'text-center',
      md: 12,
      sm: 24,
    },
    {
      key: 'equipmentImages',
      label: 'job_EquipmentConditionImages',
      validateTrigger: 'onChange',
      inputType: 'image',
      acceptFileTypes: '.png,.jpg,.jpeg,.webp',
      columnClass: 'text-center',
      md: 12,
      sm: 24,
    },
  ],
  [
    {
      key: 'errorCode',
      label: 'job_ErrorCode',
      validateTrigger: 'onChange',
      inputType: 'errorCode',
      required: true,
      options: [],
      columnClass: 'en-validation',
      md: 12,
      sm: 24,
    },
    {
      key: 'executionTime',
      label: 'job_DateNTime',
      validateTrigger: 'onChange',
      inputType: 'dateTimePicker',
      format: 'YYYY/MM/DD HH:mm:ss',
      showTime: { defaultValue: dayJs('00:00:00', 'HH:mm:ss') },
      // showTime: true,
      className: 'w-100',
      options: [],
      allowClear: true,
      md: 12,
      sm: 24,
    },
  ],
  [
    {
      key: 'errorDescription',
      label: 'job_ErrorDescription',
      validateTrigger: 'onChange',
      inputType: 'textArea',
      md: 24,
      sm: 24,
      disabled: true,
    },
  ],
  { inputType: 'quotation', label: 'job_Quotation' },
  [
    {
      key: 'actionRequired',
      label: 'job_ActionRequired',
      validateTrigger: 'onChange',
      inputType: 'textArea',
      md: 24,
      sm: 24,
    },
    {
      key: 'spareParts',
      label: 'job_SpareParts',
      validateTrigger: 'onChange',
      inputType: 'select',
      mode: 'multiple',
      options: [
        { label: 'Drain pipe', value: 'Drain pipe' },
        { label: 'Capacitor', value: 'Capacitor' },
        { label: 'Thermostat', value: 'Thermostat' },
        { label: 'Compressor', value: 'Compressor' },
      ],
      md: 24,
      sm: 24,
    },
    {
      key: 'amount',
      label: 'job_Amount',
      validateTrigger: 'onChange',
      inputType: 'inputNumber',
      className: 'w-100',
      md: 12,
      sm: 24,
    },
    {
      key: 'date',
      label: 'job_Date',
      validateTrigger: 'onChange',
      inputType: 'dateTimePicker',
      format: 'YYYY/MM/DD',
      className: 'w-100',
      allowClear: true,
      md: 12,
      sm: 24,
    },
  ],
  { inputType: 'generateQuotation' },
  { inputType: 'button', label: 'btn_Help' },
  [
    {
      key: 'action',
      label: 'job_ActionTaken',
      validateTrigger: 'onChange',
      inputType: 'textArea',
      md: 24,
      sm: 24,
    },
  ],
  { inputType: 'checklist', label: 'job_Checklist', fields: [] },
]

const installationForm = [
  {
    key: 'brandId',
    label: 'txt_Brand',
    inputType: 'parentSelector',
    required: true,
    columnClass: 'en-validation',
    showBrand: true,
    withAdd: true,
    md: 8,
    sm: 12,
    xs: 24,
  },
  {
    key: 'productSeriesId',
    label: 'txt_ProductSeries',
    inputType: 'parentSelector',
    required: true,
    columnClass: 'en-validation',
    showProduct: true,
    withAdd: true,
    isAllProductSeries: true,
    md: 8,
    sm: 12,
    xs: 24,
  },
  {
    key: 'unitType',
    label: 'job_UnitType',
    inputType: 'parentSelector',
    required: true,
    columnClass: 'en-validation',
    showUnitType: true,
    withAdd: true,
    md: 8,
    sm: 12,
    xs: 24,
  },
  {
    key: 'modelId',
    label: 'txt_Model',
    validateTrigger: 'onChange',
    inputType: 'parentSelector',
    required: true,
    columnClass: 'en-validation',
    showModel: true,
    withAdd: true,
    md: 8,
    sm: 12,
    xs: 24,
  },
  {
    key: 'location',
    label: 'job_Location',
    inputType: 'input',
    required: true,
    columnClass: 'en-validation',
    md: 8,
    sm: 12,
    xs: 24,
  },
  {
    key: 'category',
    label: 'job_Category',
    inputType: 'select',
    options: [
      { label: 'Indoor', value: 'INDOOR' },
      { label: 'Outdoor', value: 'OUTDOOR' },
    ],
    required: true,
    columnClass: 'en-validation',
    md: 8,
    sm: 12,
    xs: 24,
  },
  {
    key: 'equipmentIdentificationNumberFreeText',
    label: 'job_EquipmentSerialNumber',
    validateTrigger: 'onChange',
    inputType: 'input',
    required: true,
    md: 12,
    sm: 12,
    xs: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'refrigerantType',
    label: 'job_RefrigerantType',
    validateTrigger: 'onChange',
    inputType: 'refrigerantType',
    required: true,
    md: 12,
    sm: 12,
    xs: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'refrigerantQuantity',
    label: 'job_RefrigerantQuantity',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    md: 12,
    sm: 12,
    xs: 24,
    columnClass: 'en-validation',
    className: 'w-100',
  },
  {
    key: 'refrigerantCharge',
    label: 'job_RefrigerantCharge',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    md: 12,
    sm: 12,
    xs: 24,
    className: 'w-100',
  },
  {
    key: 'nameplateDmsId',
    label: 'job_NameplateImages',
    validateTrigger: 'onChange',
    inputType: 'image',
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
    columnClass: 'text-center',
    md: 12,
    sm: 12,
    xs: 24,
  },
  {
    key: 'equipmentDmsId',
    label: 'job_EquipmentConditionImages',
    validateTrigger: 'onChange',
    inputType: 'image',
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
    columnClass: 'text-center',
    md: 12,
    sm: 12,
    xs: 24,
  },
]

//temp until backend ready
const maintenanceChecklist = [
  {
    order: 1,
    label: 'Have you cleaned or replaced the air filters?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 2,
    label: 'Have you checked the refrigerant levels and inspected for leaks?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 3,
    label:
      'Have you inspected the electrical connections and components for wear or damage?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 4,
    label:
      'Have you checked the operation of fans and motors for unusual noises or vibrations?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 5,
    label: 'Have you cleaned the condensate drain line?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 6,
    label: 'Have you tested and calibrated the thermostat?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 7,
    label: 'Have you tested all system controls and safety features?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  {
    order: 8,
    label:
      'Have you performed a thorough inspection at the start of the cooling/heating season?',
    type: 'TOGGLE_BUTTON',
    values: ['Yes', 'No'],
    defaultValue: 'No',
    selected: [],
    imageUpload: true,
    imageCountLimit: 3,
    imageText: 'Evidence Images',
    imageDmsId: [],
  },
  // {
  //   order: 9,
  //   label: 'Other Images',
  //   type: 'IMAGE',
  //   imageUpload: false,
  //   imageCountLimit: 5,
  //   imageText: 'Evidence Images',
  //   imageDmsId: [],
  // },
]

const maintenanceJobForm = [
  {
    key: 'brand',
    label: 'txt_Brand',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 8,
    sm: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'productSeries',
    label: 'txt_ProductSeries',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 8,
    sm: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'unitType',
    label: 'job_UnitType',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 8,
    sm: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'model',
    label: 'txt_Model',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 8,
    sm: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'category',
    label: 'job_Category',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 8,
    sm: 24,
  },
  {
    key: 'location',
    label: 'job_Location',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 8,
    sm: 24,
  },
  {
    key: 'equipmentIdentificationNumber',
    label: 'job_EquipmentSerialNumber',
    validateTrigger: 'onChange',
    inputType: 'input',
    disabled: true,
    required: true,
    md: 12,
    sm: 24,
  },
  {
    key: 'refrigerantType',
    label: 'job_RefrigerantType',
    validateTrigger: 'onChange',
    inputType: 'refrigerantType',
    required: true,
    md: 12,
    sm: 24,
    columnClass: 'en-validation',
  },
  {
    key: 'refrigerantQuantity',
    label: 'job_InitialRefrigerantQuantity',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    md: 12,
    sm: 24,
    columnClass: 'en-validation',
    className: 'w-100',
  },
  {
    key: 'refrigerantCharge',
    label: 'job_InitialRefrigerantCharge',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    disabled: true,
    md: 12,
    sm: 24,
    className: 'w-100',
  },
  {
    key: 'currentCharge',
    label: 'job_CurrentCharge',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    required: true,
    md: 12,
    sm: 24,
    columnClass: 'en-validation',
    className: 'w-100',
  },
  {
    key: 'currentFillNeeded',
    label: 'job_CurrentFillNeeded',
    validateTrigger: 'onChange',
    inputType: 'inputNumber',
    disabled: true,
    md: 12,
    sm: 24,
    className: 'w-100',
  },
  { inputType: 'button', label: 'btn_Help', md: 24, sm: 24 },
  {
    inputType: 'checklist',
    label: 'job_Checklist',
    fields: [
      {
        order: 1,
        label: 'Have you cleaned or replaced the air filters?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 2,
        label:
          'Have you checked the refrigerant levels and inspected for leaks?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 3,
        label:
          'Have you inspected the electrical connections and components for wear or damage?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 4,
        label:
          'Have you checked the operation of fans and motors for unusual noises or vibrations?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 5,
        label: 'Have you cleaned the condensate drain line?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 6,
        label: 'Have you tested and calibrated the thermostat?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 7,
        label: 'Have you tested all system controls and safety features?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      {
        order: 8,
        label:
          'Have you performed a thorough inspection at the start of the cooling/heating season?',
        type: 'TOGGLE_BUTTON',
        values: ['Yes', 'No'],
        defaultValue: 'No',
        selected: [],
        imageUpload: true,
        imageCountLimit: 3,
        imageText: 'Evidence Images',
        imageDmsId: [],
      },
      // {
      //   order: 9,
      //   label: 'Other Images',
      //   type: 'IMAGE',
      //   imageUpload: false,
      //   imageCountLimit: 5,
      //   imageText: 'Evidence Images',
      //   imageDmsId: [],
      // },
    ],
  },
  {
    key: 'nameplateDmsId',
    label: 'job_NameplateImages',
    validateTrigger: 'onChange',
    inputType: 'image',
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
    columnClass: 'text-center',
    md: 12,
    sm: 24,
  },
  {
    key: 'equipmentDmsId',
    label: 'job_EquipmentConditionImages',
    validateTrigger: 'onChange',
    inputType: 'image',
    acceptFileTypes: '.png,.jpg,.jpeg,.webp',
    columnClass: 'text-center',
    md: 12,
    sm: 24,
  },
]

const repairInitialValues = {
  brand: null,
  productSeries: null,
  model: null,
  equipmentIdentificationNumber: null,
  nameplateImages: [],
  equipmentImages: [],
  errorCode: null,
  dateAndTime: null,
  errorDescription: '',
  actionTaken: '',
  otherImages: [],
}
const createRepairJobSteps = [
  'job_Date',
  'job_CustomersAndBuilding',
  'user_Dealer',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]
const createInstallationJobSteps = [
  'job_Date',
  'job_CustomersAndBuilding',
  'user_Dealer',
  'job_JobDetails',
  'job_Remarks',
  'job_Confirm',
  'job_Complete',
]

const imageFieldKeys = {
  nameplateImages: 'nameplateDmsId',
  equipmentImages: 'equipmentDmsId',
  otherImages: 'otherDmsId',
}

const initialEquipment = {
  userEinId: null,
  equipmentIdentificationNumberFreeText: null,
}

const initialErrorCode = {
  options: {},
  value: null,
  selectedOption: null,
}

const jobWiseReport = {
  REPAIR: [
    {
      title: 'job_RepairCertificate',
      subTitle: '',
      type: 'REPAIR_JOB_CERTIFICATE',
    },
  ],
  INSTALLATION: [
    {
      title: 'job_InstallationCertificate',
      subTitle: '',
      type: 'INSTALLATION_JOB_CERTIFICATE',
    },
  ],
  MAINTENANCE: [
    {
      title: 'job_MaintenanceCertificate',
      subTitle: '',
      type: 'MAINTENANCE_JOB_CERTIFICATE',
    },
  ],
}

const shareCertificateFields = t => [
  {
    name: 'phoneNumber',
    label: 'job_SendSMS',
    validation: {
      rules: [
        {
          required: false,
          max: 12,
          pattern: new RegExp(/^[0-9-]{12,12}$/),
          message: t('error_LengthValidation'),
        },
      ],
    },
  },
  {
    name: 'emailId',
    label: 'job_SendEmail',
    validation: {
      rules: [
        {
          required: false,
          type: 'email',
          pattern: new RegExp(/[a-z0-9]+@[a-z-0-9-]+\.[a-z-0-9-]{2,3}/),
          message: t('error_InvalidEmail'),
        },
      ],
    },
  },
]

const allowedRefTypes = ['UNSPECIFIED', 'MAJOR', 'CFC', 'HCFC', 'HFC']

export {
  tabKeys,
  jobTabList,
  defaultJobTab,
  columnKeys,
  searchByKeys,
  searchByLabels,
  payloadType,
  repairForm,
  repairInitialValues,
  createRepairJobSteps,
  imageFieldKeys,
  initialEquipment,
  initialErrorCode,
  jobWiseReport,
  shareCertificateFields,
  createInstallationJobSteps,
  installationForm,
  allowedRefTypes,
  maintenanceJobForm,
  maintenanceChecklist,
  jobsTypesUrl,
}
